import type { IAttribution } from '@repo/analytics';
import type { IPageContext } from './page-context-from-pathname';

const EMPTY_ATTRIBUTION: IAttribution = {
  source: null,
  medium: null,
  campaign: null,
  term: null,
  content: null,
  referrer: null,
  gclid: null,
  fbclid: null,
  ttclid: null,
  msclkid: null,
  rawUrl: null,
  referrerUserId: null,
  landingTemplate: null,
  landingPhrase: null,
  channel: null,
  socialRef: null,
  touchKind: 'event',
  capturedAt: 0,
};

export function buildInstallIntentPayload(
  cookie: IAttribution | null,
  page: IPageContext,
  channel: string,
  referrerHost: string | null,
): IAttribution {
  const base = cookie ?? EMPTY_ATTRIBUTION;
  return {
    ...base,
    referrer: base.referrer ?? referrerHost,
    rawUrl: window.location.href.slice(0, 500),
    landingTemplate: page.template,
    landingPhrase: page.phrase,
    channel,
    socialRef: base.socialRef,
    touchKind: 'event',
    capturedAt: Date.now(),
  };
}
